export default "__VITE_ASSET__bjs7nOca__"